var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home animated fadeIn"},[(_vm.specificService)?_c('f-intro-emk'):_c('f-intro-home'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
export { render, staticRenderFns }